<template>
<v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
        <v-col cols="12" class="pa-0">
            <v-row class="py-1 px-5">
                <v-col cols="12" md="12" LeadsPannel>
                    <v-row>
                        <v-col cols="12" LEADSPANEL>
                          
                            <v-card :loading="loading">
                                <v-card-text class="py-0">
                                    <v-row class="align-center">
                                        <v-col cols="12">
                                            <v-row class="align-center">
                                                <v-col cols="10" TITLE>
                                                    <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{ i18n['formList'] }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        </v-row>
                                    </v-card-text>
                            
                                    <v-card-text> 
                                        <div v-if="subscription_active===false">
                                            <div style="text-align: center; margin: 40px; font-size: 22px;">
                                                <div> {{ arabic ? 'اشتراكك غير مفعل رجاء اختر خطة لاستخدام هذه الخدمة' : 'Your subscription not Active to use this service please choose plan.' }}</div>
                                                <v-btn 
                                                    color="primary" 
                                                    class="mt-3" 
                                                    style="width: 300px;" 
                                                    @click="navigateToPlanPrice">
                                                    {{ arabic ? 'ترقية الخطة' : 'Plan Upgrade' }}
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div v-else-if="subscription_active===true">
                                    <v-row>
                                    <v-col cols="12" class=" py-0">

                                        <v-row>
                                            <v-col cols="4" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">

                                                        <v-btn 
                                                            color="success" 
                                                            :class="`${arabic ? 'arFont' : 'enFont'}`"
                                                            style="width: 300px;" 
                                                            @click="goToCreate">
                                                            {{ arabic ? 'انشاء نموذج' : 'Create Form' }}
                                                        </v-btn>                                  
                                                    </v-col>


                                                    <v-col cols="4" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">

                                                           <v-btn color="success" block @click="videoDialog = true">{{i18n['intro_video']}}</v-btn>
                                                            <VideoDialog @close="closeVideoDialog" :dialog="videoDialog">
                                                                <iframe width="100%" height="540"  src="https://www.youtube.com/embed/FedzfPNZEug?si=35Dj6OUhmA1fFU7T" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>  
                                                            </VideoDialog>
                                                    </v-col>
                                                </v-row>

                                        <v-card-text>
                                            <ListFilter :i18n="i18n" @filter-applied="onFilterApplied" />
                                            <v-row>
                                                <v-col cols="12">
                                                    <div class="text-center my-3">
                                                        <v-btn color="success" :loading="loading" text small @click="reload()">{{i18n['reload']}}</v-btn>
                                                    </div>
                                                    <v-dialog v-model="showDialog" persistent max-width="800px">
                                                        <v-card>
                                                            <v-card-title>
                                                                Form Details
                                                                <v-spacer></v-spacer>
                                                                <v-btn icon @click="showDialog = false">
                                                                    <v-icon>mdi-close</v-icon>
                                                                </v-btn>
                                                            </v-card-title>
                                                            <v-card-text>
                                                                <CustomForm :formUuid="selectedFormUuid"></CustomForm> <!-- Use your component here -->
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-dialog>

                                                    <v-pagination v-model="currentPage" :length="totalPages" @input="fetchForms" ></v-pagination>
                
                                                    <v-simple-table >
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">No</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['name'] }}</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">UUID</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['title'] }}</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['country'] }}</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['form_submission'] }}</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['form_views'] }}</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">Action</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{i18n['Results']}}</th>
                                                                    <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{i18n['duplicates']}}</th>
                                                                    


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="form in forms" :key="form.id" text-center>
                                                                    <td>{{form.id }}</td>
                                                                    <td>{{form.name }}</td>
                                                                    <td>
                                                                        <v-row align="center" no-gutters>
                                                                            <v-col cols="9">
                                                                                <v-text-field v-model="form.embed_code"></v-text-field>
                                                                            </v-col>
                                                                            <v-col cols="3">
                                                                                <v-btn v-clipboard:copy="form.embed_code" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler" color="success" x-small icon>
                                                                                    <v-icon size="10">content_copy</v-icon>
                                                                                </v-btn>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </td>

                                                                    <td>{{form.title }}</td>
                                                                    <td v-if="form.country">{{form.country.name }}</td>
                                                                    <td>{{form.submission_count }}</td>
                                                                    <td>{{form.view_count }}</td>
                                                                    <td>
                                                                    <v-btn color="primary" x-small icon @click="editForm(form.id)" class="ml-2">
                                                                        <v-icon size="20">edit</v-icon>
                                                                    </v-btn>
                                                                        <v-btn color="primary" x-small icon @click="showForm(form.uuid)" class="mr-2">
                                                                            <v-icon size="20">visibility</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn color="success" small class="ml-2" :class="`${arabic ? 'arFont' : 'enFont'}`" @click="FormResult(form.id)">
                                                                                {{ i18n['Result'] }}
                                                                        </v-btn>
                                                                    </td>
                                                                    <td>
                                                                        <v-dialog persistent max-width="600">
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn color="success" small class="ml-2" :class="`${arabic ? 'arFont' : 'enFont'}`" v-bind="attrs" v-on="on"> {{ i18n['Repeat_the_form'] }}</v-btn>
                                                                                </template>
                                                                                <template v-slot:default="dialog">
                                                                                        <v-card :loading="loading">
                                                                                                <v-card-title :class="`${arabic?'arFont':'enFont'}`"  style="font-size:20px">
                                                                                                    <v-row class="align-center fill-height">
                                                                                                        <v-col cols="12" md="11" :class="`${arabic?'arFont':'enFont'} fill-height`">
                                                                                                            {{i18n['sure_dublicate_form']}}
                                                                                                        </v-col>
                                                                                                    </v-row>
                                                                                                </v-card-title>
                                                                                                <v-card-text>
                                                                                                        <v-row class="align-center fill-height">
                                                                                                            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`" v-if="loading">
                                                                                                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`">
                                                                                                                <v-card-actions>
                                                                                                                    <v-btn color="primary" small class="ml-2" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                                                                                                        @click="dialog.value = false">{{ i18n['cancel'] }}
                                                                                                                    </v-btn>

                                                                                                                    <v-btn 
                                                                                                                    :disabled="limit_count_form_subscription =='limit_form_count'"
                                                                                                                    small class="ml-2" :class="`${arabic ? 'arFont' : 'enFont'}`" color="success" @click="RepeatForm(form.id)">
                                                                                                                        {{ i18n['confirm_dublicate'] }}
                                                                                                                    </v-btn>

                                                                                                                </v-card-actions>
                                                                                                            </v-col>
                                                                                                        
                                                                                                        </v-row>
                                                                                                </v-card-text>
                                                                                         </v-card>
                                                                                </template>
                                                                        </v-dialog>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <v-pagination v-model="currentPage" :length="totalPages" @input="fetchForms" ></v-pagination>
                                                </v-col>
                                            </v-row>

                                        </v-card-text>

                                    </v-col>
                                </v-row>
                                        </div>
                                   </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>

            </v-row>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
// import axios from 'axios';
import ListFilter from '@/components/FormBuilder/ListFilter.vue';
import CustomForm from '@/components/FormBuilder/FormPreview.vue';
import VideoDialog from '@/components/VideoDialog.vue';

export default {
    props: {
    formUuid: String,
},
    components: {
        ListFilter,
        CustomForm,
        VideoDialog,
        

    },
    data() {
        return {
            videoDialog:false,
            subscription_active:true,
            currentPage: 1,
            limit: 10,
            totalPages: 0,
            forms: [],
            loading: false,
            fromDate: "", // Changed from a specific date to an empty string
            toDate: "", // Changed from a specific date to an empty string
            inputSearch: "",
            showDialog: false,
        selectedFormUuid: null,
        limit_count_form_subscription:"",

        };
    },
    methods: {

        clipboardSuccessHandler() {
        this.$emit('snackbarNotification', `Copied`, 'success')
      },
      clipboardErrorHandler() {
        this.$emit('snackbarNotification', `Failed`, 'error')
      },
        getEmbedCode(uuid) {
            const scriptCode1 = '<script ninja="ninja-form" src="https://form.ninjasellers.com/js/ninja_sellers_embedded.js">';
            const scriptCode2 = '</  script >'.replace(/ /g,'');
            const string = '<div ninja-form-id="' + uuid + '"></div>' + scriptCode1 + scriptCode2;
            return string;
        },
        showForm(formUuid) {
            this.selectedFormUuid = formUuid;
        this.showDialog = true;
    },
    async reload() {
      this.fetchForms()
    },
    
    async fetchForms() {
    this.loading = true;
    try {
        const response = await this.$store.dispatch('getResource', {
            resource: '/getForms' + `?page=${this.currentPage}`,
            limit: this.limit,
            filters:{
                fromDate: this.fromDate,
                toDate: this.toDate,
                inputSearch: this.inputSearch
            },
        });

        if (response.original != undefined) {
            this.subscription_active = response.original.subscription_active;
        } else {
            this.subscription_active = true;
        }

        this.forms = response.forms.data.map(form=> ({...form, embed_code:this.getEmbedCode(form.uuid)}));
        // if(response.status !=''){
        //     this.limit_count_form_subscription=response.status;
        //   // alert(this.limit_count_form_subscription);
        // }else{
        //     this.limit_count_form_subscription='';

        // }
        console.log(this.forms);
        // console.log('this.forms', response)
        this.totalPages = response.forms.last_page;
    } catch (error) {
        console.error("Failed to fetch forms:", error);
    } finally {
        this.loading = false;
    }
},


        onFilterApplied(filters) {
            this.fromDate = filters.fromDate;
            this.toDate = filters.toDate;
            this.inputSearch = filters.inputSearch;
            this.currentPage = 1;
            this.fetchForms();
        },
      
        editForm(id) {
            this.$router.push(`/FormBuilder/form/Edit/${id}`);
        },
        FormResult(id)
        {
           this.$router.push(`/FormBuilder/List/FormSubmissionResult/${id}`);
        },
        navigateToPlanPrice() {
      this.$router.push({ name: 'plan_price' });
    },
    goToCreate()
    {
        this.$router.push({ name: 'form_create' });
   
    },
    closeVideoDialog(){
			this.videoDialog = false
		},

        async RepeatForm(id) {
            try {
                this.loading = true;
                const response = await this.$store.dispatch('postResource', { resource: '/formRepate', value: { id: id } });
                console.log("Successfully duplicated this form:", response);
                this.reload();
            } catch (error) {
                console.error("Failed to duplicate this form:", error);
            } finally {
                this.loading = false;
            }
        },

        async returnFormCount() {
    try {
        const payload = {
            resource: "/FormCount",
        };
        const FormCount = await this.$store.dispatch('getResource', payload);
        this.limit_count_form_subscription = FormCount.status;
        console.log('FormCount Data:', this.limit_count_form_subscription);
    } catch (error) {
        console.error("Failed to fetch FormCount:", error);
    }
}



    },
    watch: {
        currentPage() {
            this.fetchForms();
        }
    },
    computed: {
        language() {
            return this.$store.state.language;
        },
        i18n() {
            return this.$store.state.i18n[this.$store.state.language];
        },
        arabic() {
            return this.$store.state.language === "ar";
        },
        uuid() {
        return this.$route.params.uuid;
      }
    },
    mounted() {
        console.log('Component is mounted, fetching forms...');
        this.fetchForms();
        this.returnFormCount();
    }
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>
